import React from "react";
import { ProSidebar, Menu, MenuItem, SidebarHeader, SidebarContent } from 'react-pro-sidebar';
import { useAuth } from "../utilities/auth";
import logo from "../images/logo.png";

function SideBar(props) {
  const { userData } = useAuth();
  const canManageLeagues = userData && Number(userData.role) === 6;

  return (
    <ProSidebar collapsed={props.collapsed}>
      <SidebarHeader>
        <div className="sideBarHeader">
          <img src={logo} className="sideBarHeaderLogo" alt="Лого" />
          <div className="sideBarHeaderTitle"><p>inGame</p></div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <Menu iconShape="square">
          <MenuItem><div onClick={()=>props.goTo('/admin')} className="sidebar-row">Управление матчами </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/applications_managment')} className="sidebar-row">Управление заявками </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/black_list')} className="sidebar-row">Черный список </div></MenuItem>
          {/* Menu клонирует каждого ребёнка и падает на false/null,
              поэтому скрытый пункт убираем из списка, а не оставляем пустым */}
          {[
            canManageLeagues && (
              <MenuItem key="leagues"><div onClick={()=>props.goTo('/leagues_management')} className="sidebar-row">Управление лигами </div></MenuItem>
            ),
            canManageLeagues && (
              <MenuItem key="partners"><div onClick={()=>props.goTo('/partners_management')} className="sidebar-row">Управление спонсорами </div></MenuItem>
            ),
          ].filter(Boolean)}
          <MenuItem><div onClick={()=>props.goTo('/stages_management')} className="sidebar-row">Управление стадиями </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/league_champions')} className="sidebar-row">Призеры лиги </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/league_tour_team')} className="sidebar-row">Сборная тура </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/league_disqualifications')} className="sidebar-row">Дисквалификации </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/select_match_media')} className="sidebar-row">Управление медиа </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/teams_management')} className="sidebar-row">Управление командами </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/players_management')} className="sidebar-row">Управление игроками </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/schedule_management')} className="sidebar-row">Управление расписанием </div></MenuItem>
          <MenuItem><div onClick={()=>props.goTo('/infographics')} className="sidebar-row">Инфографика </div></MenuItem>
        </Menu>
    </SidebarContent>
  </ProSidebar>
  );
}

export default SideBar;